import { LOCALES, SUPPORTED_LOCALES, type SupportedLocale } from '../../constants/locales';

const LANGUAGE_KEY = 'LANGUAGE';
// Set once the one-off switch to Ukrainian has run in this browser, so a user
// who picks another language afterwards keeps it.
const UK_DEFAULT_MIGRATED_KEY = 'LANGUAGE_UK_DEFAULT_MIGRATED';

/**
 * The app locale to start with. Ukrainian is the default; every browser is
 * moved to Ukrainian once (even if it had English stored), after which the
 * stored choice is respected.
 */
export const resolveInitialLocale = (): SupportedLocale => {
  if (!localStorage.getItem(UK_DEFAULT_MIGRATED_KEY)) {
    localStorage.setItem(LANGUAGE_KEY, LOCALES.UA);
    localStorage.setItem(UK_DEFAULT_MIGRATED_KEY, '1');
  }
  const stored = localStorage.getItem(LANGUAGE_KEY);
  if (SUPPORTED_LOCALES.includes(stored as SupportedLocale)) {
    return stored as SupportedLocale;
  }
  localStorage.setItem(LANGUAGE_KEY, LOCALES.UA);
  return LOCALES.UA as SupportedLocale;
};
